import React from "react";
import { assets } from "../../../Assets/assets";
import { MdOutlineStars } from "react-icons/md";
import LabelHeading from "../../common/LabelHeading";

const Advantage = ({ id }) => {
  const perks = [
    "Client Appreciation and Best Talent Delivery",
    "Tried and Tested Selection Process",
    "Top Staffing Agency Recognition",
  ];

  return (
    <section id={id} className="w-full bg-[#012E5B]">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2">

        <div style={{ backgroundImage: `url(${assets.servicebg})` }} className="text-white px-6 md:px-12 py-12 flex flex-col justify-center overflow-hidden">
          <div data-aos="fade-up-right" data-aos-duration="1000" className="relative z-10 space-y-6">
            <LabelHeading
              label="Advantages"
              heading="Natio Advantages"
              light={true}
              position="left"
            />

            <p className="text-[15px] leading-relaxed max-w-[420px] text-[#DBE7F2]">
              We are dedicated to building lifelong associations with our clients
              through exceptional staffing and recruiting solutions.
            </p>

            <ul className="space-y-4 mt-6">
              {perks.map((item, index) => (
                <li data-aos="fade-up" data-aos-duration="1000" data-aos-delay={index * 100} key={index} className="flex items-center gap-3 text-[15px] text-[#EAF4FF]">
                  <MdOutlineStars className="text-3xl mt-1" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div data-aos="fade-up-left" data-aos-duration="1000">
          <img
            src={assets.advantageimg}
            alt="Advantage"
            className="w-full h-[350px] md:h-[25rem] object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default Advantage;
